export default [
    {
        type: 'custom',
        itemStyle: {
            width: '100%',
            height: '50vw'
        }
    },
    {
        style: {
            margin: '30px 20px'
        },
        title: true
    },
    {
        style: {
            marginBottom: '20px'
        },
        avatar: true,
        row: 1
    },
    {
        type: 'custom',
        style: {
            margin: '20px'
        },
        itemStyle: {
            width: '100%',
            height: '70px',
        }
    },
    {
        type: 'custom',
        style: {
            margin: '20px'
        },
        itemStyle: {
            width: '100%',
            height: '70px',
        }
    },
    {
        type: 'custom',
        style: {
            margin: '20px'
        },
        itemStyle: {
            width: '100%',
            height: '70px',
        }
    },
    {
        type: 'custom',
        style: {
            margin: '20px'
        },
        itemStyle: {
            width: '100%',
            height: '80vw',
        }
    },
    {
        style: {
            margin: '0 20px 40px'
        },
        row: 15
    }
];